import { Tooltip } from "@mui/material";

const APP_TOOLTIP_SLOT_PROPS = { popper: { sx: { zIndex: 2100 } } };

const AppTooltip = ({ title, placement = "top", children }) => {
  if (!title) return children;
  return (
    <Tooltip title={title} arrow enterDelay={100} placement={placement} slotProps={APP_TOOLTIP_SLOT_PROPS}>
      {children}
    </Tooltip>
  );
};

export default AppTooltip;
